/*
 * `?field=<name>&comment=<id>` on the workspace URL (comment notifications and
 * emails link here, next to `?open=form:<id>`): read once and dropped, so a
 * refresh does not jump back to the thread.
 */
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

import { FORM_COMMENT_PARAMS, readCommentLink } from "../commentsModel";

export const useCommentDeepLink = (): {
  fieldName: string | null;
  commentId: string | null;
} => {
  const [params, setParams] = useSearchParams();
  const initial = useRef(readCommentLink(params.toString()));
  useEffect(() => {
    if (
      !params.has(FORM_COMMENT_PARAMS.field) &&
      !params.has(FORM_COMMENT_PARAMS.comment)
    )
      return;
    const next = new URLSearchParams(params);
    next.delete(FORM_COMMENT_PARAMS.field);
    next.delete(FORM_COMMENT_PARAMS.comment);
    setParams(next, { replace: true });
    // Once, on mount.
  }, []);
  return initial.current;
};
